import { toast } from 'sonner'
import ROUTES from '@/routes/routes'

let leaving = false

/** The user can no longer be in this room: say so, then take them home. */
export function leaveRoom(message: string) {
  if (leaving) return
  leaving = true
  toast.error(message, { duration: 3000 })
  setTimeout(() => {
    window.location.href = ROUTES.ROOT
  }, 1500)
}
